import React from 'react'
import { useSelector } from 'react-redux'
import { LayoutSwitcher } from 'components'
import { NavigationMemberLyfe, User, Search } from '../components'
import './index.styl'
import c from 'classnames'

const Authorized = () => {
  const { isMobile } = useSelector(state => state.session)
  return (
    <div className={c('authorizedHeader', { authorizedHeaderMob: isMobile === true })}>
      {isMobile
        ? (
          <>
            <NavigationMemberLyfe />
            <div className='authorizedLogo'>
              <LayoutSwitcher type='member' />
            </div>
            <Search />
          </>)
        : (
          <>
            <LayoutSwitcher type='member' />
            <NavigationMemberLyfe />
            <Search />
          </>)}
      <User />
    </div>
  )
}

export default Authorized
